import { render, staticRenderFns } from "./m-form-address.vue?vue&type=template&id=96615bfe&scoped=true&"
import script from "./m-form-address.vue?vue&type=script&lang=js&"
export * from "./m-form-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96615bfe",
  null
  
)

export default component.exports